$.fn.extend({
    'cushion': function (this: JQuery, options: Record<string, any>) {
        options = $.extend({
            linkSelector: '.link',
            readableLinkBoxSelector: '.readable-link',
            readableLinkTextSelector: '.readable-link small',
            errorMessageMissing: 'URL not specified',
            errorMessageInvalid: 'Invalid URL specified'
        }, options);

        const self = this;

        const queryParameters = new URLSearchParams(location.search);
        const href = queryParameters.get('to');

        if (!href) {
            setTimeout(function () {
                self.trigger('cushion:error', options.errorMessageMissing);
            }, 0);
            return this;
        }

        if (!href.match(/^([a-z]+:)?\/\//)) {
            setTimeout(function () {
                self.trigger('cushion:error', options.errorMessageInvalid);
            }, 0);
            return this;
        }

        this.find(options.linkSelector).attr('href', href).text(href);

        // const readableFormHref = Encoding.convert(Encoding.urlDecode(href), {
        //     to: 'UNICODE',
        //     type: 'string'
        // });
        const readableFormHref = decodeURIComponent(href);

        if (readableFormHref !== href) {
            this.find(options.readableLinkTextSelector).text(readableFormHref);
            this.find(options.readableLinkBoxSelector).show();
        } else {
            this.find(options.readableLinkBoxSelector).hide();
        }

        setTimeout(function () {
            self.trigger('cushion:done');
        }, 0);

        return this;
    }
})
